import { render } from "./SelectCompany.vue?vue&type=template&id=1a1c1ccf"
import script from "./SelectCompany.vue?vue&type=script&lang=js"
export * from "./SelectCompany.vue?vue&type=script&lang=js"

import "./SelectCompany.vue?vue&type=style&index=0&id=1a1c1ccf&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__